// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rattan_pillow_form/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rattan_pillow_form: ModuleSchema = {
  "id": "core_rattan_pillow_form",
  "uniqueId": "B3D_RPF01",
  "createdAt": "2026-10-15T00:00:00Z",
  "updatedAt": "2026-10-23T03:14:08.071Z",
  "label": "Woven Rattan Pillow",
  "description": "Standalone rounded-square woven rattan pillow, using the sinusoidal strand pattern from core_rattan_lattice.",
  "category": "core_geometry",
  "tags": [
    "core",
    "rattan",
    "pillow",
    "form",
    "woven"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Width (mm)",
      "min": 80,
      "max": 200,
      "default": 133.8,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "depth",
      "label": "Depth (mm)",
      "min": 80,
      "max": 200,
      "default": 133.8,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Height (mm)",
      "min": 5,
      "max": 80,
      "default": 39.4,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "cornerRadius",
      "label": "Corner Radius (mm)",
      "min": 2,
      "max": 60,
      "default": 20,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness (mm)",
      "min": 0.4,
      "max": 2.5,
      "default": 0.84,
      "step": 0.02,
      "unit": "mm"
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch (mm)",
      "min": 1.5,
      "max": 12,
      "default": 4,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude (mm)",
      "min": 0.4,
      "max": 4,
      "default": 1.5,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "bellyRadius",
      "label": "Belly Radius (mm, max H/2)",
      "min": 0.5,
      "max": 40,
      "default": 13,
      "step": 0.5,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "rattan_pillow_form",
      "label": "Woven Rattan Pillow",
      "default": "#D97706",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "rattan_pillow_form_object",
      "label": "Rattan Pillow Form",
      "name": "Rattan Pillow Form",
      "color": "#D97706",
      "parts": [
        {
          "id": "rattan_pillow_form",
          "label": "Woven Rattan Pillow",
          "name": "Woven Rattan Pillow",
          "groupId": 0,
          "colorKey": "rattan_pillow_form",
          "defaultColor": "#D97706",
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "form",
      "label": "Woven Rattan Pillow",
      "targetGroupId": 0,
      "default": true
    }
  ]
};
